export const actions = {
  set: 'SET::USER'
}

export const setUser = user => ({ type: actions.set, user })

export default actions